/** Matches the "Name (date):" label each exported comment line starts with; dates come as YYYY-MM-DD or MM-DD-YYYY. */
export const COMMENT_LABEL_PATTERN =
  /^(.+?\(\d{1,4}[-/]\d{1,2}[-/]\d{1,4}\):)(.*)$/;

/**
 * Hidden, export-only column holding the formatted comments. Kept distinct
 * from the "comments" field_key so columns_config visibility never shows it.
 */
export const COMMENTS_EXPORT_COLUMN_ID = "comments_export";

export const ATTACHMENT_ADDED_TEXT = "(Attachment added)";

/** The API ends a comment that has attachments with their count, e.g. "(2 attachments)". */
const ATTACHMENT_COUNT_SUFFIX = /\s*\(\d+\s+attachments?\)\s*$/i;

const formatComment = (comment: string): string => {
  const hasAttachmentCount = ATTACHMENT_COUNT_SUFFIX.test(comment);
  const withoutCount = comment.replace(ATTACHMENT_COUNT_SUFFIX, "");
  const match = COMMENT_LABEL_PATTERN.exec(withoutCount);
  const text = (match ? match[2] : withoutCount).trim();

  // A labelled comment with no text was posted with attachments only.
  if (match && !text) return `${match[1]} ${ATTACHMENT_ADDED_TEXT}`;
  if (!hasAttachmentCount) return comment;
  return match
    ? `${match[1]} ${text} ${ATTACHMENT_ADDED_TEXT}`
    : `${text} ${ATTACHMENT_ADDED_TEXT}`.trim();
};

/**
 * Joins comments one per line for exports. Attachments read as
 * "(Attachment added)" after the comment text, without their count.
 */
export function formatCommentsForExport(comments?: string[] | null): string {
  return (comments ?? []).map(formatComment).join("\n");
}
